import { render, staticRenderFns } from "./addSupplierModal.vue?vue&type=template&id=24532858&scoped=true"
import script from "./addSupplierModal.vue?vue&type=script&lang=js"
export * from "./addSupplierModal.vue?vue&type=script&lang=js"
import style0 from "./addSupplierModal.vue?vue&type=style&index=0&id=24532858&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24532858",
  null
  
)

export default component.exports